export const ABOUT_HISTORY = {
  title: 'Our story',
  paragraphs: [
    'Kappa Theta Pi is the first professional technology fraternity in the country, founded on January 10, 2012. What began as a small group of students passionate about technology has grown into a national organization with chapters across the country.',
    'The UChicago Theta Chapter brings together students from across campus — computer scientists, designers, economists, researchers, and more — united by a shared love for building with technology.',
    'Our alumni network spans startups, research labs, and companies across the country. They remain connected to the chapter through mentorship, recruiting events, and lifelong friendships.',
  ],
  image: 'assets/img/about/film.jpg',
  imageAlt: 'KTP members at a chapter event',
} as const;

export const ABOUT_PILLARS = [
  {
    title: 'Professional Development',
    description:
      'Interview training, resume workshops, one-on-one mentorship, and recruiting events that prepare members for tech careers.',
  },
  {
    title: 'Technical Advancement',
    description:
      'Workshops, hackathons, and collaborative learning that help members grow as builders, engineers, and technologists.',
  },
  {
    title: 'Community',
    description:
      'Social events, retreats, and traditions that create lasting friendships across classes and backgrounds.',
  },
  {
    title: 'Alumni Mentorship',
    description:
      'A tight-knit alumni network working at companies from startups to major tech firms, providing guidance and opportunity.',
  },
  {
    title: 'Academic Support',
    description:
      'A supportive network of some of the brightest tech minds on campus, ready to help with coursework and extracurriculars.',
  },
] as const;
